import Admin from "./Admin";
import Broker from "./Broker";

const screens = ({ user }) => [
  ...Broker(user?.permissions),
  ...Admin(user?.permissions),
];

export default screens;
